import { getIntFromQuery, type PastaRoute, routePaginationHandler } from "@pasta/box-v2";
import { useAuthStore } from "@pasta/front-auth-v2";
import AdminTagsList from "./admin-tags-list.vue";
import { type RouteLocationNormalized } from "vue-router";
import { loadAppContext } from "../app/router/load-app-context.middleware";

export const routes: PastaRoute[] = [
  {
    name: "admin-tags",
    path: "/admin-tags",
    component: AdminTagsList,
    props: (to: RouteLocationNormalized) => {
      return {
        ...routePaginationHandler(to),
        pageSize: getIntFromQuery(to.query.pageSize, 10),
      };
    },
    beforeEnter: [
      loadAppContext,
      () => {
        if (useAuthStore().ability.cannot("create", "LetterFileTag")) {
          return { path: "/", name: "home" };
        }
      },
    ],
  },
];
